import React, { Component } from "react";
import Dashboard from "./Dashboard";
import FitbitDashboard from "./FitbitDashboard";
import AirboxDashboard from "./AirboxDashboard";
import Airbox2Dashboard from "./Airbox2Dashboard";
import GarminDashboard from "./GarminDashboard";
import GarminSDKDashboard from "./GarminSDKDashboard";
import Home from "./Home";
import Login from "./Login";
import Signup from "./Signup";
import UserSignup from "./user/Signup";
import UserLogin from "./user/Login";
import Groups from "./Groups";
import Info from "./garmin/Info";
import UserInfo from "./user/Info";
import ConfirmInfo from "./garmin/ConfirmInfo";
import GarminData from "./garmin/GarminData";
import GarminGroups from "./garmin/Groups";
import {
  BrowserRouter as Router,
  Route,
  Redirect,
  withRouter
} from "react-router-dom";
import { MuiThemeProvider } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Patients from "./Patients";
import Longgood from "./Longgood";
import theme from "./theme";
import "./App.css";

class PrivateRoute extends React.Component {
  state = {
    loaded: false,
    isAuthenticated: false
  };
  componentDidMount() {
    this.authenticate();
  }
  async authenticate() {
    try {
      const result = await fetch(`/api/isAuthenticated`, {
        mode: "cors",
        method: "GET"
      });

      const data = await result.json();

      if (data.success) {
        this.setState({ loaded: true, isAuthenticated: true });
      } else {
        this.setState({ loaded: true, isAuthenticated: false });
      }
    } catch (err) {
      this.props.history.push("/login");
    }
  }
  render() {
    const { component: Component, ...rest } = this.props;
    const { loaded, isAuthenticated } = this.state;
    if (!loaded) return null;
    return (
      <Route
        {...rest}
        render={props => {
          return isAuthenticated ? (
            <Component {...props} />
          ) : (
            <Redirect
              to={{
                pathname: "/login"
              }}
            />
          );
        }}
      />
    );
  }
}

PrivateRoute = withRouter(PrivateRoute);

class App extends Component {
  render() {
    return (
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
        <Router>
          <div>
            <Route exact default path="/" component={Home} />
            <Route path="/login" component={Login} />
            <Route path="/signup" component={Signup} />
            <Route path="/user/signup" component={UserSignup} />
            <Route path="/user/login" component={UserLogin} />
            <PrivateRoute path="/user/info" component={UserInfo} />
            {/*
            <Route path="/garmin/user/info" component={Info} />
            <Route path="/garmin/user/confirminfo" component={ConfirmInfo} />
            <Route path="/garmin/user/data" component={GarminData} />
            */}
            <PrivateRoute path="/groups" component={Groups} />
            <PrivateRoute path="/:uniqid/patients" component={Patients} />
            <PrivateRoute path="/:uniqid/longgood" component={Longgood} />
            <PrivateRoute path="/:uniqid/fitbit" component={FitbitDashboard} />
            <PrivateRoute path="/:uniqid/airbox" component={AirboxDashboard} />
            <PrivateRoute path="/:uniqid/airbox2" component={Airbox2Dashboard} />
            <PrivateRoute path="/:uniqid/garmin" component={GarminDashboard} />
            <PrivateRoute path="/:uniqid/garminsdk" component={GarminSDKDashboard} />
            <PrivateRoute path="/:uniqid/:id/dashboard" component={Dashboard} />
          </div>
        </Router>
      </MuiThemeProvider>
    );
  }
}

export default App;
